import { render, staticRenderFns } from "./listSummaryBranch.vue?vue&type=template&id=23b323e1&scoped=true"
import script from "./listSummaryBranch.vue?vue&type=script&lang=js"
export * from "./listSummaryBranch.vue?vue&type=script&lang=js"
import style0 from "./listSummaryBranch.vue?vue&type=style&index=0&id=23b323e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b323e1",
  null
  
)

export default component.exports